import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackChangedPersonDetails.meta';

export type UseTrackChangedPersonDetailsParams = {
  person_id: string;
  new_name?: string;
  new_title?: string;
  location:
    | 'image-preview'
    | 'people-tab'
    | 'named-people-page'
    | 'unnamed-people-page'
    | 'person-page-header'
    | 'person-page-menu'
    | 'people-settings';
};

export const useTrackChangedPersonDetails = () => {
  const { track } = useAnalyticsUtilities();

  const trackChangedPersonDetails = useCallback(
    (params: UseTrackChangedPersonDetailsParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackChangedPersonDetails };
};
